export default class Enum {
  constructor(name, desc) {
    this.name = name;
    this.desc = desc;
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.name;
  }

  /**
   * 引数が当Enumと一致するかどうかチェック（Proxyが渡されることを想定）
   *
   * @param target
   * @returns {boolean}
   */
  is (target) {
    return this.name === target?.name;
  }

  get description() {
    return this.desc;
  }

  /**
   * 指定した名前のEnumを返す
   *
   * @param name
   * @returns {null}
   */
  static of(name) {
    if (name && this.hasOwnProperty(name)) {
      return this[name];
    }
  }

  /**
   * 項目の一覧を返す
   *
   * @returns {(* | Enum | (function(): *))[]}
   */
  static values() {
    return Object.values(this).filter(v => v instanceof Enum);
  }
}
